class BulkOrder extends HTMLElement {
  constructor() {
    super();
    this.storageKey = `bulk-order-storage`;
    this.addButton = this.querySelector('input[type="button"]');
    this.form = this.querySelector('form');
    this.alert = this.querySelector('.alert');
    this.alertMessage = this.querySelector('.alert p');
    this.errors = false;
    this.pageLinkButton = document.querySelector('.js-page-link');
    if (this.form) {
      this.form.addEventListener('submit', this.formSubmit.bind(this));
    }
    this.pageLinkButton.addEventListener('click', this.linkToPage.bind(this));
    if (window.location.href.includes('bulk-order-page')) {
      this.fillFormFormStorage();
    }
    // if (this.addButton) {
    //   this.addButton.addEventListener('click', this.addItemInput.bind(this));
    // }
  }

  async fillFormFormStorage() {
    this.localStorageGetItem = localStorage.getItem(this.storageKey);
    const array = Object.values(JSON.parse(this.localStorageGetItem));
    const rows = this.form.querySelectorAll('.inputs[data-type="page"] .row');
    if (rows.length > 0) {
      await array.forEach(item => {
        rows.forEach((row, index) => {
          if (index === item.index) {
            const skuInput = row.querySelector('input[name="sku"]');
            const quantityInput = row.querySelector('input[name="quantity"]');
            skuInput.value = item.sku
            quantityInput.value = item.quantity
          }
        });
      })
      this.updateLocalStorage('')
    }
  }

  updateLocalStorage(newData) {
    JSON.parse(localStorage.getItem(this.storageKey));
    localStorage.setItem(this.storageKey, JSON.stringify({
      ...newData
    }));
  }

  reset() {
    this.querySelectorAll('input[type="hidden"]').forEach((input) => {
      input.remove();
    });
    this.handleErrors("", false);
  }

  async linkToPage() {
    const popupForm = document.querySelector('#popup-form');
    const formData = new FormData(popupForm);
    const inputs = formData.getAll("sku");
    // const skus = formData.get("skus");

    const rows = await Promise.all(inputs.filter(input => input).map(async (sku, i) => {
      const quantity = formData.getAll("quantity")[i];
      await this.handleHiddenInputs(sku, quantity, i)
      const row = {index: i, sku, quantity}
      return row
    }))
    this.updateLocalStorage(rows)
  }

  // addItemInput() {
  //   const inputs = this.querySelector(".inputs");
  //   const row = document.createElement("div");
  //   row.classList.add("row");
  //   row.innerHTML += `
  //       <div class="col-sm-9">
  //           <p class="contact-name">
  //               <input class="sku-input" placeholder="Item #" type="text" name="sku">
  //           </p>
  //       </div>
  //       <div class="col-sm-2">
  //           <p class="contact-email">
  //               <quantity-input class="quantity">
  //                   <button class="quantity__button" name="minus" type="button">–
  //                   </button>
  //                   <input
  //                           class="quantity__input"
  //                           type="number"
  //                           name="quantity"
  //                           value="1"
  //                           min="1"
  //                   />
  //                   <button class="quantity__button"
  //                           name="plus" type="button">+
  //                   </button>
  //                   <legend class="quantity__placeholder">Qty</legend>
  //               </quantity-input>
  //           </p>
  //       </div>
  //   `;
  //   inputs.appendChild(row);
  // }


  setPopup(text, image, product) {
    // used from theme's itemAddedCallback()
    // document.querySelector(".product-popup .product-name").innerText = text;
    // document.querySelector(".product-popup .product-image img").src = image;

    $('.product-popup').find('.popup-products').append(this.productTemplate(text, image, product))
  }

  resetPopup() {
    $('.mini-product-item').remove()
  }

  productTemplate(text, image, data) {
    return `<div class="mini-product-item row" data-id="${text}">
      <div class="col-md-3 col-sm-3 product-image f-left">
        <img alt="img" src="${image}" style="max-width:120px; height:auto"/>
      </div>

      <div class="col-md-9 col-sm-9">
        <div class="product-info">
          <p class="product-name">${text}</p>
          <p class="success-message">Added to cart successfully!</p>
        </div>
      </div>
    </div>`
  }

  handleErrors(error, enable = true, type = '') {
    this.alertMessage.innerText = error;

    this.alert.style.backgroundColor = "#E52B50"
    this.alert.style.borderColor = "#E52B50"
    this.alert.style.color = "#fff"
    if (enable) {
      this.alert.style.display = "block";
      this.errors = true;
    } else {
      this.alert.style.display = "none";
      this.errors = false;
    }
  }

  async handleHiddenInputs(sku, quantity, i) {
    if (!sku) {
      this.handleErrors("No item sku entered.");
      return;
    }
    if (!quantity || quantity < 1) {
      this.handleErrors("Wrong item number entered.");
      return;
    }

    const product = await this.getProductBySKU(sku);

    if (product) {
      const input_id = document.createElement("input");
      const input_quantity = document.createElement("input");

      input_id.setAttribute("type", "hidden");
      input_id.setAttribute("name", `items[${i}]id`);
      input_id.setAttribute("value", product.id);

      input_quantity.setAttribute("type", "hidden");
      input_quantity.setAttribute("name", `items[${i}]quantity`);
      input_quantity.setAttribute("value", quantity);

      this.setPopup(product.title, product.image, product);

      this.form.appendChild(input_id);
      this.form.appendChild(input_quantity);
    }
  }

  async getProductBySKU(searchTerm) {
    try {
      const response = await fetch(`/search/suggest?q=${searchTerm}&resources[type]=product&resources[options][fields]=title,product_type,body,variants.title,vendor,tag,variants.sku&section_id=bulk-order-search`);

      if (!response.ok) {
        const error = new Error(response.status);
        throw error;
      }

      const text = await response.text();

      console.log('text:', text);

      const {
        product,
        status
      } = JSON.parse(new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-bulk-order-search').innerText);

      console.log('product:', product);

      if (status != "success") {
        this.handleErrors(`${searchTerm} is not a valid item number.`);
        // return "not found";
      } else {
        let availableFlag = null

        await fetch(`/search/suggest.json?q=id:${product.id}&resources[type]=product&limit=1`)
          .then(response => {
            if (!response.ok) {
              throw new Error('Network response was not ok');
            }
            return response.json();
          })
          .then(product => {
            console.log('checkkkk:',product.resources.results.products[0]);
            availableFlag = product.resources.results.products[0].available

            // if (!product.resources.results.products[0].available) {
            //   this.handleErrors(`${searchTerm} is out of stock`);
            // }
          })
          .catch(error => {
            console.error('There was a problem with the fetch operation:', error);
            return false;
          });
        console.log('availableFlag:',availableFlag);
        console.log('availableFlagTypeOf:',typeof availableFlag);
        if(availableFlag){
          console.log('gogog')
          let res = product.variants.find(variant => variant.sku == searchTerm);
          console.log('test test:', product);
          if (!res) {
            return product.variants[0]
          } else {
            return product.variants.find(variant => variant.sku == searchTerm);
          }
        }else{
          this.handleErrors(`${searchTerm} is out of stock`);
        }

        // console.log('res:',res);
        // return product.variants.find(variant => variant.sku == searchTerm);
      }

    } catch (error) {
      throw error;
    }


  }

  async formSubmit(e) {
    e.preventDefault();
    this.resetPopup()
    this.reset();

    const formData = new FormData(this.form);
    let inputs = formData.getAll("sku");
    const skus = formData.get("skus");
    let quantity1 = formData.getAll("quantity");
    let flag = false

    const rows = []

    for (let i in inputs) {
      if (inputs[i] !== '' || skus?.length) {
        flag = true
      }

      if (inputs[i] === '') {
        rows.push($(`.inputs .row:nth-child(${Number(i) + 1})`))
      }
    }


    if (flag) {
      for (let i in rows) {
        $(rows[i]).remove()
      }

      for (let i in rows) {
        $('.inputs').append(rows[i])
      }

      inputs = null
      inputs = new FormData(this.querySelector('form')).getAll("sku");
      quantity1 = formData.getAll("quantity");

      await Promise.all(inputs.filter(input => input).map(async (sku, i) => {
        const quantity = new FormData(this.querySelector('form')).getAll("quantity")[i];
        await this.handleHiddenInputs(sku, quantity, i)
      }))

      if (skus) {
        await Promise.all(skus.replace(/ /g, '').split(/\r?\n/).filter(input => input).map(async (line, i) => {
          const [sku, quantity] = line.split(",");
          await this.handleHiddenInputs(sku, quantity, inputs.length + i);
        }))
      }

      if (!this.errors) {
        ShopifyAPI.addItemFromForm(this.form, ajaxCart.load);
      }

    } else {
      this.handleErrors("All fields is empty", true, 'error')
    }

  }
}

customElements.define('bulk-order', BulkOrder);